export default "__VITE_ASSET__e3aca59c__"